export default function Preview({ command }) {
    return (
        <span className="ms-3">
            {command.settings.recording ? (
                <span className="text-success">Enable</span>
            ) : (
                <span className="text-danger">Disable</span>
            )}
            {" payload"}
        </span>
    );
}
